import "./New.css";
import { Sidebar } from "../../components/sidebar/Sidebar";
import { Navbar } from "../../components/navbar/Navbar";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { useState } from "react";
import axios from "axios"; // Assurez-vous qu'axios est installé

const NewProduct = () => {
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    brand: "",
    quantity: 1,
    price: "",
    description: "",
    productCondition: "new",
    color: "",
    size: "",
    username: "",
  });

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === "category" && value !== "Vêtements" ? { size: "" } : {}), // Réinitialise la taille si la catégorie n'est pas "Vêtements"
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      name,
      category,
      brand,
      quantity,
      price,
      description,
      productCondition,
      color,
      size,
      username,
    } = formData;

    // Validation des champs
    if (!name || !category || !price || !description) {
      setError("Veuillez remplir tous les champs requis.");
      return;
    }

    const productData = {
      name,
      category,
      brand,
      quantity: parseInt(quantity, 10),
      price: parseFloat(price),
      description,
      productCondition,
      color,
      size,
      username,
    };
  

    const formDataToSend = new FormData();
    formDataToSend.append("productData", JSON.stringify(productData));
    if (file) {
      formDataToSend.append("productImage", file);
    }

    try {
      const response = await axios.post("http://localhost:5000/api/products/add", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 201) {
        setSuccessMessage("Produit ajouté avec succès !");
        setError("");
        setFormData({
          name: "",
          category: "",
          brand: "",
          quantity: 1,
          price: "",
          description: "",
          productCondition: "new",
          color: "",
          size: "",
          username: "",
        });
        setFile(null);
      }
    } catch (error) {
      console.error("Erreur lors de l'ajout du produit :", error);
      setError("Erreur lors de l'ajout du produit. Veuillez réessayer.");
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>Ajouter un nouveau Produit</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <img
              src={
                file
                  ? URL.createObjectURL(file)
                  : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
              }
              alt="Aperçu"
            />
          </div>
          <div className="right">
            <form onSubmit={handleSubmit}>
              <div className="formInput">
                <label htmlFor="file">
                  Image : <DriveFolderUploadIcon className="icon" />
                </label>
                <input
                  type="file"
                  id="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  style={{ display: "none" }}
                />
              </div>

              <div className="formInput">
                <label>Nom du produit</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="formInput">
                <label>Catégories</label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Choisir la catégorie</option>
                  <option value="Electronique">Electronique</option>
                  <option value="Cuisine">Cuisine</option>
                  <option value="Soins et Beauté">Soins et Beauté</option>
                  <option value="Vêtements">Vêtements</option>
                  <option value="Téléphones et Tablette">Téléphones et Tablettes</option>
                  <option value="Maison et Bureau">Maison et Bureau</option>
                </select>
              </div>
              <div className="formInput">
                <label>Marque</label>
                <input
                  type="text"
                  name="brand"
                  value={formData.brand}
                  onChange={handleInputChange}
                />
              </div>
              <div className="formInput">
                <label>Quantité</label>
                <input
                  type="number"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleInputChange}
                  min="1"
                  required
                />
              </div>
              <div className="formInput">
                <label>Prix</label>
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="formInput">
                <label>Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="formInput">
                <label>Condition</label>
                <select
                  name="productCondition"
                  value={formData.productCondition}
                  onChange={handleInputChange}
                >
                  <option value="new">Neuf</option>
                  <option value="used">Occasion</option>
                </select>
              </div>
              <div className="formInput">
                <label>Couleur</label>
                <input
                  type="text"
                  name="color"
                  value={formData.color}
                  onChange={handleInputChange}
                />
              </div>
              {formData.category === "Vêtements" && (
                <div className="formInput">
                  <label>Taille</label>
                  <input
                    type="text"
                    name="size"
                    value={formData.size}
                    onChange={handleInputChange}
                  />
                </div>
              )}

              {error && <p className="error">{error}</p>}
              {successMessage && <p className="success">{successMessage}</p>}

              <button type="submit">Enregistrer</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProduct;
